import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AdvancedPetitionFilters from "../../components/petitions/AdvancedPetitionFilters/AdvancedPetitionFilters";
import Dropdown from "../../components/petitions/PetitionsFilter.jsx/Dropdown/Dropdown";
import PetitionsFilter from "../../components/petitions/PetitionsFilter.jsx/PetitionsFilter";
import PetitionsList from "../../components/petitions/PetitionsList/PetitionsList";
import { getPetitions } from "../../store/petition/petitionActions";

const PetitionsPage = () => {
  const { petitions } = useSelector((state) => state.petitions);
  const { t } = useTranslation("global");
  const [filteredPetitions, setFilteredPetitions] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(t("dropDown.popular"));
  const [useAdvancedFilters, setUseAdvancedFilters] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPetitions());
  }, [dispatch]);

  const filterPetitions = (filter) => {
    const petitionsCopy = [...petitions];
    // Преобразуем переведенный фильтр обратно в ключ для сравнения
    const filterKey = filter === t("dropDown.popular") ? "popular" :
                     filter === t("dropDown.new") ? "new" :
                     filter === t("dropDown.old") ? "old" :
                     filter === t("dropDown.completed") ? "completed" : filter;
    
    switch (filterKey) {
      case "popular":
      case "Популярные":
        return petitionsCopy.sort((a, b) => (b.support_votes || b.pro || 0) - (a.support_votes || a.pro || 0));
      case "new":
      case "Сначала новые":
        return petitionsCopy.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
      case "old":
      case "Сначала старые":
        return petitionsCopy.sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        );
      case "completed":
      case "Завершенные":
        return petitionsCopy.filter(
          (petition) => petition.status === "Завершенная"
        );
      default:
        return petitionsCopy;
    }
  };

  const handleSort = (filter) => {
    setSelectedFilter(filter);
    setFilteredPetitions(filterPetitions(filter));
    setUseAdvancedFilters(false);
  };

  const handleAdvancedFilter = (results) => {
    if (results === null) {
      // Сброс фильтров - показать все
      setFilteredPetitions([]);
      setUseAdvancedFilters(false);
    } else {
      // Применены расширенные фильтры
      setFilteredPetitions(results);
      setUseAdvancedFilters(true);
    }
  };

  return (
    <div>
      <div className="container">
  {/* <PetitionSearch /> */}
        <AdvancedPetitionFilters onFilterResults={handleAdvancedFilter} />
        <PetitionsFilter />
        {/*<Dropdown handleSort={handleSort} selectedFilter={selectedFilter} />*/}
      </div>
      <PetitionsList
        petitions={useAdvancedFilters || filteredPetitions.length ? filteredPetitions : petitions}
      />
    </div>
  );
};

export default PetitionsPage;
